var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.dictionary),function(entry){return _c('brand-listing',{key:entry[0],attrs:{"entry":entry}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }